/**
 * app/layouts/LayoutAuth.tsx
 * Layout para pantallas de autenticación.
 * Si ya hay sesión, redirige al POS.
 */

import { Outlet, Navigate } from 'react-router-dom'
import { useAuthContext } from '../providers/AuthProvider'

export function LayoutAuth() {
  const { session, loading } = useAuthContext()

  // Ya autenticado → ir al POS
  if (!loading && session) {
    return <Navigate to="/pos" replace />
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-navy-950 via-navy-900 to-navy-800 flex flex-col">
      {/* Header de marca */}
      <div className="flex-shrink-0 pt-12 pb-8 text-center">
        <div className="inline-flex items-center gap-3">
          <span className="text-4xl">📱</span>
          <div>
            <div className="text-3xl font-black text-white tracking-tight leading-none">
              CELMAXX
            </div>
            <div className="text-xs text-brand-400 font-semibold tracking-widest mt-0.5">
              PUNTO DE VENTA
            </div>
          </div>
        </div>
      </div>

      {/* Contenido (LoginPage) */}
      <div className="flex-1 flex items-start justify-center px-4">
        <div className="w-full max-w-sm">
          <Outlet />
        </div>
      </div>

      {/* Footer */}
      <div className="flex-shrink-0 py-6 text-center text-surface-600 text-xs">
        v{__APP_BUILD__.appVersion} · {__APP_BUILD__.gitSha.slice(0, 7)} · CELMAXX/G-TIDE
      </div>
    </div>
  )
}
